import { useCallback, useEffect, useState } from "react";
import { unlockAudio, startRing, stopRing, getAudioState } from "@/lib/ringtone";

const TAG = "arathri-incoming-call";

const showNotification = async (title, body) => {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  const opts = { body, icon: "/icons/icon-192.png", badge: "/icons/icon-192.png", tag: TAG, renotify: true, requireInteraction: true, vibrate: [400, 150, 400, 150, 400], data: { url: window.location.pathname } };
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    if (reg) return await reg.showNotification(title, opts);
  } catch (e) { /* fall through */ }
  try { new Notification(title, opts); } catch (e) { /* ignore */ }
};

const closeNotification = async () => {
  try {
    const reg = await navigator.serviceWorker?.getRegistration();
    const list = (await reg?.getNotifications({ tag: TAG })) || [];
    list.forEach((n) => n.close());
  } catch (e) { /* ignore */ }
};

export function useIncomingAlerts(call, role) {
  const [soundReady, setSoundReady] = useState(getAudioState() === "running");
  const [notifPerm, setNotifPerm] = useState(("Notification" in window) ? Notification.permission : "unsupported");
  const status = call?.status;

  useEffect(() => {
    const unlock = async () => { if (await unlockAudio()) setSoundReady(true); };
    unlock();
    const evs = ["pointerdown", "keydown", "touchstart"];
    evs.forEach((e) => window.addEventListener(e, unlock, { passive: true }));
    return () => evs.forEach((e) => window.removeEventListener(e, unlock));
  }, []);

  useEffect(() => {
    const incoming = status === "incoming";
    const ringing = status === "ringing";
    if (incoming || ringing) {
      unlockAudio().then((ok) => { if (ok) setSoundReady(true); startRing(incoming ? "incoming" : "ringback"); });
      if (incoming) {
        showNotification(`📞 ഇൻകമിംഗ് ${call.type === "video" ? "വീഡിയോ" : "ഓഡിയോ"} കോൾ`, `${call.peerName} വിളിക്കുന്നു — ആപ്പ് തുറന്ന് അറ്റൻഡ് ചെയ്യുക`);
        if (navigator.vibrate) navigator.vibrate([400, 150, 400, 150, 400]);
        document.title = `📞 ${call.peerName} വിളിക്കുന്നു — ഏരാത്രി`;
      }
      return () => { stopRing(); document.title = "രാത്രി | RATHRI"; };
    }
    stopRing();
    if (role === "staff") closeNotification();
    return undefined;
  }, [status, soundReady, role, call?.type, call?.peerName]);

  const requestNotifications = useCallback(async () => {
    if (!("Notification" in window)) return;
    const p = await Notification.requestPermission();
    setNotifPerm(p);
    await unlockAudio().then((ok) => ok && setSoundReady(true));
  }, []);

  return { soundReady, notifPerm, requestNotifications };
}
